import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getHost = () => window.location.hostname;

export const getAuthBaseUrl = () => {
  const host = getHost();

  let url = `//${host.replace('admin.', `auth.`)}`;

  if (process.env.REACT_APP_STAGE === 'local') {
    url += `:${process.env.REACT_APP_CLIENT_AUTH_PORT}`;
  }

  return url;
};

export const getEventDomain = () => {
  let url = `${process.env.REACT_APP_DOMAIN}`;

  if (process.env.REACT_APP_STAGE !== 'prod') {
    url = `${process.env.REACT_APP_STAGE}.${url}`;
  }

  if (process.env.REACT_APP_STAGE === 'local') {
    url += `:${process.env.REACT_APP_CLIENT_EVENT_PORT}`;
  }

  return url;
};

export const getDomainOrSubdomain = () =>
  window.location.hostname
    .replace('admin.', '')
    .replace(`${process.env.REACT_APP_STAGE}.`, '')
    .split(`.${process.env.REACT_APP_DOMAIN}`)
    .join('');

export const isDefaultRoute = () => {
  const route = getDomainOrSubdomain();

  return process.env.REACT_APP_DOMAIN === route;
};

export const getDefaultFirebaseConfig = () => ({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
});

export const roundNumber = (value) => Math.round((value + Number.EPSILON) * 100) / 100;

export const numberFormat = (value) =>
  new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  }).format(value);

export const weekdaysIndex = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6
};

export const getTimeZoneDate = ({ date, timeZone = 'Europe/Lisbon' }) => {
  const localeDate = new Date(date).toLocaleString('en', { timeZone });
  return dayjs(localeDate).tz(timeZone, true);
};

export const getTimeZoneDateStart = ({ date, timeZone = 'Europe/Lisbon' }) => {
  const localeDate = new Date(date).toLocaleString('en', { timeZone });
  return dayjs(localeDate)
    .set('hour', 0)
    .set('minute', 0)
    .set('second', 0)
    .set('millisecond', 0)
    .tz(timeZone, true);
};

export const getTimeZoneDateEnd = ({ date, timeZone = 'Europe/Lisbon' }) => {
  const localeDate = new Date(date).toLocaleString('en', { timeZone });
  return dayjs(localeDate)
    .set('hour', 23)
    .set('minute', 59)
    .set('second', 59)
    .set('millisecond', 999)
    .tz(timeZone, true);
};

export const getTimeZoneGTM = ({ date, timeZone = 'Europe/Lisbon' }) =>
  dayjs(date).tz(timeZone, true).format('Z');
